// pages/_app.js

import "@/styles/globals.css";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { GoogleAnalytics } from "nextjs-google-analytics";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import "react-notifications/lib/notifications.css";
import { Toaster } from "react-hot-toast";
import NextNProgress from "nextjs-progressbar";
import { useEffect, useState } from "react";
import Snowfall from 'react-snowfall'

export default function App({ Component, pageProps }) {
  const [buildId, setBuildId] = useState(null);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (buildId) return;

    fetch("/api/build")
      .then((res) => res.json())
      .then((data) => {
        setBuildId(data?.buildId || "N/A");
      });
  }, []);

  const { isStaging, shouldSnowFall } = pageProps;

  return (
    <div className="font-sans">
      <GoogleAnalytics trackPageViews />
      <NextNProgress color="#ffffff" options={{ easing: "ease", speed: 250 }} />
      <Toaster position="top-right" />

      {shouldSnowFall && (
        <div
          className="fixed top-0 left-0 w-full h-full pointer-events-none z-10"
        >
          <Snowfall />
        </div>
      )}

      {isStaging && (
        <div className="fixed top-0 left-0 w-full bg-black z-50">
          <div
            className="bg-yellow-900/25 border-y border-yellow-500 text-yellow-300 text-sm text-center font-semibold p-2"
            style={{ height: "40px" }}
          >
            ⚠️ This is the staging version of the Combat Warriors website. We
            cannot guarantee that everything will work as expected.
          </div>
        </div>
      )}

      <header
        className="fixed w-full z-40"
        style={{ top: isStaging ? "40px" : "0px" }}
      >
        <Navbar />
      </header>

      <Component {...pageProps} />
      <Footer buildId={buildId} />
    </div>
  );
}

App.getInitialProps = async ({ Component, ctx }) => {
  let pageProps = {};
  if (Component.getInitialProps) {
    pageProps = await Component.getInitialProps(ctx);
  }
  pageProps.isStaging = process.env.STAGING === "true";
  const currentDay = new Date().getDate();
  const currentMonth = new Date().getMonth();
  pageProps.shouldSnowFall = currentMonth === 11 && currentDay <= 25;
  return { pageProps };
};
